export default {"src":"/_next/static/media/full.532dccd2.svg","height":24,"width":102,"blurWidth":0,"blurHeight":0};